import React from 'react';
import CabVendorTemp from './cabVendorTemp';
import Breadcrumbs from "../../../components/breadcrumbs";
import { Box, Typography } from "@mui/material";


const CabVendorManagement = () => {
    return (
        <>
            <Box p='30px'>
                <Breadcrumbs content={["Dashboard", "Cab Vendor"]} />
                <Box p='15px 0'>
                    <Typography variant='t24_700' > Cab Vendor </Typography>
                </Box>
                <CabVendorTemp />
            </Box>
        </>
    )
}

export default CabVendorManagement;